import { Pipe, PipeTransform } from '@angular/core';
import { Addon } from '@app/shared/interfaces';

@Pipe({
  standalone: false,
  name: 'findBasePrioritySupportAddon',
})
export class FindBasePrioritySupportAddonPipe implements PipeTransform {
  transform(addons: Addon[]): Addon | null {
    return (
      addons.find(
        (addon) =>
          addon.description.includes('Priority Support') && !addon.description.includes('Priority Support Per Property')
      ) || null
    );
  }
}
